const s = {
  root: { minHeight: '100vh', background: '#050505', color: '#fff', padding: '0 20px', fontFamily: "'Euclid Circular B', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif", WebkitFontSmoothing: 'antialiased' },
  inner: { maxWidth: 760, margin: '0 auto' },
  back: { display: 'inline-block', padding: '20px 0 12px', color: 'rgba(255,255,255,.5)', textDecoration: 'none', fontSize: 14, transition: 'color .15s' },
  h1: { fontSize: 36, fontWeight: 800, letterSpacing: '-0.03em', margin: '0 0 8px' },
  meta: { color: 'rgba(255,255,255,.45)', fontSize: 14, marginBottom: 48 },
  h2: { fontSize: 20, fontWeight: 700, letterSpacing: '-0.02em', margin: '40px 0 12px', color: '#fff' },
  p: { color: 'rgba(255,255,255,.7)', fontSize: 15, lineHeight: 1.7, margin: '0 0 16px' },
  ul: { color: 'rgba(255,255,255,.7)', fontSize: 15, lineHeight: 1.7, margin: '0 0 16px', paddingLeft: 24 },
  li: { marginBottom: 6 },
  contact: { marginTop: 48, paddingBottom: 80 },
  a: { color: '#FF7E67', textDecoration: 'none' },
};

export default function TermsScreen() {
  return (
    <div style={s.root}>
      <div style={s.inner}>
        <a href="/" style={s.back}>← Back to Flux URO</a>
      </div>
      <div style={{ ...s.inner, paddingBottom: 80 }}>
        <h1 style={s.h1}>Terms of Service</h1>
        <p style={s.meta}>Effective Date: June 2026 · Flux Uro FZ-LLC · UAE</p>

        <h2 style={s.h2}>1. Acceptance</h2>
        <p style={s.p}>
          By using Flux URO's services, APIs, or website, you agree to these Terms of Service. If you do not agree, do not use our platform.
        </p>

        <h2 style={s.h2}>2. Services</h2>
        <p style={s.p}>
          Flux URO provides AI services including but not limited to image generation, video generation, upscaling, prompt refinement, and workflow automation. Services are offered on a pay-as-you-go basis unless otherwise agreed.
        </p>

        <h2 style={s.h2}>3. User Responsibilities</h2>
        <p style={s.p}>You agree to:</p>
        <ul style={s.ul}>
          <li style={s.li}>Use services legally and ethically</li>
          <li style={s.li}>Not reverse-engineer or exploit the platform</li>
          <li style={s.li}>Maintain accurate account information</li>
          <li style={s.li}>Respect model licensing and copyright laws</li>
          <li style={s.li}>Not use the platform to generate illegal, harmful, or deceptive content</li>
        </ul>

        <h2 style={s.h2}>4. Intellectual Property</h2>
        <p style={s.p}>
          You retain ownership of your uploaded prompts, media, and generated content. Flux URO does not claim ownership of your outputs but may store this data to provide services and analytics.
        </p>

        <h2 style={s.h2}>5. Payments and Credits</h2>
        <ul style={s.ul}>
          <li style={s.li}>$1 USD = 1 URO credit</li>
          <li style={s.li}>Pricing depends on model and GPU cost</li>
          <li style={s.li}>No refunds on used credits</li>
          <li style={s.li}>Free credits may expire after 30 days; purchased credits do not expire</li>
          <li style={s.li}>Enterprise discounts are subject to a separate contract</li>
        </ul>

        <h2 style={s.h2}>6. Account Termination</h2>
        <p style={s.p}>
          We reserve the right to suspend or terminate accounts for abuse, fraud, or violations of these Terms. You may also request account deletion at any time by contacting{' '}
          <a href="mailto:support@fluxuro.ai" style={s.a}>support@fluxuro.ai</a>.
        </p>

        <h2 style={s.h2}>7. Disclaimers</h2>
        <p style={s.p}>
          We provide services "as-is." We do not guarantee model output accuracy, reliability, or fitness for a particular purpose. AI-generated content may be imperfect or unexpected.
        </p>

        <h2 style={s.h2}>8. Limitation of Liability</h2>
        <p style={s.p}>
          Flux URO shall not be liable for indirect, incidental, or consequential damages arising from use of the platform. Our total liability is limited to the amount you paid in the past 6 months.
        </p>

        <h2 style={s.h2}>9. Dispute Resolution</h2>
        <p style={s.p}>
          All disputes are governed by the laws of the United Arab Emirates. Venue will be Dubai Courts or the DIFC Courts, unless contractually overridden.
        </p>

        <h2 style={s.h2}>10. Changes to These Terms</h2>
        <p style={s.p}>
          We may revise these Terms at any time. Continued use of the platform after changes are posted implies acceptance of the latest version. We will notify users of significant changes via email or platform notification.
        </p>

        <div style={{ marginTop: 48, padding: '24px', borderRadius: 16, border: '1px solid rgba(255,255,255,.08)', background: 'rgba(255,255,255,.03)' }}>
          <p style={{ ...s.p, margin: 0 }}>
            Questions about these Terms? Contact us at{' '}
            <a href="mailto:support@fluxuro.ai" style={s.a}>support@fluxuro.ai</a>
            {' '}or join our{' '}
            <a href="https://discord.gg/4b6S849Y2t" style={s.a} target="_blank" rel="noopener noreferrer">Discord</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
